module.exports = require("./uz-Cyrl");